import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import LocationCard from './LocationCard';
import { locationCardStyles } from './styles';
import AddOrEditLocation from './AddOrEditLocation';

export default function LocationsList() {
  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewLocationModalOpen, setAddNewLocationModalOpen] = useState(false);

  const getLocations = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/location/?search=${searchText}`)
      .then(res => {
        setLocations(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewLocationModalClose = () => {
    getLocations();
    setAddNewLocationModalOpen(false);
  };

  useEffect(() => {
    // Fetch locations on mount
    getLocations();
  }, [getLocations]);

  return (
    <>
      <SearchBar label="Search a location..." setQuery={setSearchText} />
      <div style={locationCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewLocationModalOpen(true)}>
          Location
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={locations}
            emptyMessage="No locations found."
            // @ts-ignore
            CardComponent={LocationCard}
            onLocationDelete={getLocations}
            onLocationUpdate={getLocations}
          />
          <AddOrEditLocation
            onSave={onNewLocationModalClose}
            modalTitle="Add new location"
            isModalOpen={addNewLocationModalOpen}
            setModalOpen={setAddNewLocationModalOpen}
          />
        </>
      )}
    </>
  );
}
